export default __webpack_public_path__ + "static/MediaContentNine-06270d0b10c45bdd75c11e2ec9b7517a.webp";